import { RadioTile, TileGroup, Tooltip } from 'carbon-components-react';
import React, { useEffect } from 'react';
import { QuesIDProps } from '../../Maas360Estimator';
import { segmentsTracking } from 'src/common/lib/tracker';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';
import { convertToString } from 'src/apps/maas360-estimator/lib/utils';

type Step2Props = {
  que2Value: string;
  setQue2Value: React.Dispatch<React.SetStateAction<string>>;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  setTrackQuesID: React.Dispatch<React.SetStateAction<QuesIDProps>>;
  trackQuesID: QuesIDProps;
  useTranslation: TranslationFunction;
};

const Step2 = ({
  que2Value,
  setQue2Value,
  setIsRequired,
  setTrackQuesID,
  trackQuesID,
  useTranslation,
}: Step2Props) => {
  useEffect(() => {
    if (que2Value) {
      setIsRequired(false);
    }
  }, []);

  const handleClick = (
    value: string,
    event: React.MouseEvent<HTMLInputElement>,
  ) => {
    setQue2Value(value);
    setIsRequired(false);
    setTrackQuesID({
      ...trackQuesID,
      Q2: (event.target as HTMLInputElement).id,
    });
    segmentsTracking('CTA Clicked', {
      pageTitle: 'MaaS360 Plan Assessment',
      object: 'Mass360 page',
      resultValue: 'CTA clicked',
      CTA: `question 2 - ${value} - selected`,
      location: 'Assessment',
      action: '',
      field: '',
    });
  };

  const yes = convertToString(useTranslation('yes'));
  const no = convertToString(useTranslation('no'));

  return (
    <div>
      <div className="page_sub_heading padding_8">
        {useTranslation('que_2_text_desc')}
        <Tooltip
          className="maas360_widget__maas360-tooltip"
          onChange={() => {
            // For segment tracking
            segmentsTracking('CTA Clicked', {
              pageTitle: 'MaaS360 Plan Assessment',
              object: 'Mass360 page',
              resultValue: 'CTA clicked',
              CTA: `question 2 - tooltip`,
              location: 'Assessment',
              action: '',
              field: '',
            });
          }}
          direction="right"
          tabIndex={0}
        >
          <span className="slide_text">
            {useTranslation('que_2_text_tooltip')}
          </span>
        </Tooltip>
      </div>
      <TileGroup
        name="radio-group"
        className="tilegroup"
        valueSelected={que2Value}
      >
        <RadioTile
          className="tile"
          id="Q2A1"
          value="Yes"
          onClick={(e) => handleClick(yes, e)}
        >
          {useTranslation('yes')}
        </RadioTile>
        <RadioTile
          className="tile"
          id="Q2A2"
          value="No"
          onClick={(e) => handleClick(no, e)}
        >
          {useTranslation('no')}
        </RadioTile>
      </TileGroup>
    </div>
  );
};

export default Step2;
